module.exports = {
      id: "loading-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "svg-sprite-b11c226f9ecc9a258e9645c9abf2e2fd.svg#loading",
      toString: function () {
        return this.url;
      }
    }